import React from "react";
import Header from "./HeaderPO";
import InfoCard from "./InfoCard";
import PODetails from "./PODetails";
import ItemsTable from "./ItemsTable";
import POFooter from "./POFooter";
import POTermsAndCondition from "./POTermsAndCondition";

const PurchaseOrderForm = ({
  pdfRef,
  isPOData,
  isViewMode,
  isCampaignList,
  downloadPDF,
  setPOData,
  isEditMode,
  errors,
  handleUpdatePO,
  handleGeneratePO,
  listLoading,
  setErrors,
  termsRef,
  footerRef,
}) => {
  return (
    <>
      {/* MAIN PO CONTENT */}
      <div
        ref={pdfRef}
        className="mx-auto max-w-[1400px] border bg-white shadow-sm"
      >
        <Header
          isLatestPONumber={isPOData.poNumber}
          isViewMode={isViewMode}
          downloadPDF={downloadPDF}
          isPOData={isPOData}
        />

        <div className="h-[1px] w-[97%] bg-gray-300 mx-auto" />

        <InfoCard
          isCampaignList={isCampaignList}
          isPOData={isPOData}
          setPOData={setPOData}
          isViewMode={isViewMode}
          errors={errors}
          listLoading={listLoading}
        />

        <div className="h-[1px] w-[97%] bg-gray-300 mx-auto" />

        <PODetails
          isPOData={isPOData}
          setPOData={setPOData}
          isViewMode={isViewMode}
          isEditMode={isEditMode}
          errors={errors}
          setErrors={setErrors}
        />

        <div className="h-[1px] w-[97%] bg-gray-300 mx-auto" />

        <ItemsTable
          isPOData={isPOData}
          setPOData={setPOData}
          isViewMode={isViewMode}
          isEditMode={isEditMode}
          errors={errors}
          setErrors={setErrors}
        />
      </div>

      {/* FOOTER - SEPARATE REF */}
      <div
        ref={footerRef}
        className="mx-auto max-w-[1400px] border bg-white shadow-sm"
      >
        <POFooter
          handleGeneratePO={handleGeneratePO}
          setPOData={setPOData}
          isPOData={isPOData}
          isViewMode={isViewMode}
          isEditMode={isEditMode}
          handleUpdatePO={handleUpdatePO}
          errors={errors}
        />
      </div>

      {/* TERMS */}
      <div
        ref={termsRef}
        className="mx-auto max-w-[1400px] border bg-white shadow-sm"
      >
        <POTermsAndCondition isViewMode={isViewMode} isPOData={isPOData} />
      </div>
    </>
  );
};

export default PurchaseOrderForm;
